var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader'),_c('div',{staticClass:"dashboard--wrapper clearfix container"},[_c('div',{staticClass:"content margin-bottom-80"},[_c('router-view',[(_vm.isSidebarVisible && !_vm.isMobile)?_c('sidebar'):_vm._e()],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }